import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import React from 'react';

import Text from 'commons/Text';
import Colors from 'configs/Colors';

const HeaderSection = ({ title, onClose, classes }) => (
  <div className={classes.header}>
    <Text
      type="lg"
      fontWeightBold
      color={Colors.Grey10}
    >
      {title}
    </Text>
    <IconButton
      onClick={onClose}
      className={classes.iconButton}
      size="small"
    >
      <CloseIcon />
    </IconButton>
  </div>
);

export default HeaderSection;
